import React from "react";
import { FormLabel } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from "recharts";
import tag from "../../../../../assets/images/tag.png";
import TagCloudContainer from "../../../../core/TagCloud";

const Occurrences = ({
  label,
  occurrences,
  onOccurrenceClick,
  xDataKey,
  yDataKey,
  viewType,
  infoWidgetImage
}) => {
  return (
    <>
      <div className="containerShadow">
        <div className="infoWidget animationPulse">
          {viewType === "barchart" ? (
            <div className="bamBarChart">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Image
                  className="infoWidgetImage"
                  src={infoWidgetImage}
                ></Image>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12">
                <FormLabel className="infoWidgetLabel">{label}</FormLabel>
              </div>
              <div className="responsiveContainer">
                <ResponsiveContainer width="95%" height={196}>
                  <BarChart data={occurrences} layout="vertical">
                    <Bar
                      barSize={20}
                      dataKey={xDataKey}
                      fill="var(--bar-chart)"
                      onClick={onOccurrenceClick}
                      className="selectable"
                    ></Bar>
                    <XAxis dataKey={xDataKey} hide type="number" />
                    <YAxis dataKey={yDataKey} type="category" width={145} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          ) : viewType === "tagcloud" ? (
            <div className="bamBarChart">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Image className="infoWidgetImage" src={tag}></Image>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12">
                <FormLabel className="infoWidgetLabel">{label}</FormLabel>
              </div>
              <div className="responsiveContainer">
                <div className="popularTags">
                  <TagCloudContainer
                    data={occurrences}
                    callbacks={{ onWordClick: onOccurrenceClick }}
                  />
                </div>
              </div>
            </div>
          ) : undefined}
        </div>
      </div>
    </>
  );
};

export default Occurrences;
